import { RootState } from "../store";

export const selectAgencyClients = (state: RootState) => state.agency.clients;
export const selectAgencyLoading = (state: RootState) => state.agency.loading;
export const selectAgencyLoadError = (state: RootState) => state.agency.loadError;
export const selectAgencyAddLoading = (state: RootState) => state.agency.addLoading;
export const selectAgencyAddError = (state: RootState) => state.agency.addError;
export const selectAgencyEnableLoading = (state: RootState) => state.agency.enableLoading;
export const selectAgencyEnableError = (state: RootState) => state.agency.enableError;
export const selectAgencyInviteLoading = (state: RootState) => state.agency.inviteLoading;
export const selectAgencyInviteError = (state: RootState) => state.agency.inviteError;
export const selectAgencyCreateLoading = (state: RootState) => state.agency.createLoading;
export const selectAgencyCreateError = (state: RootState) => state.agency.createError;
export const selectAgencyRenameLoading = (state: RootState) => state.agency.renameLoading;
export const selectAgencyRenameError = (state: RootState) => state.agency.renameError;
